<div class="container py-4">
  <div class="card mx-auto p-4" style="max-width: 560px">
    <h5 class="mb-4">Cambiar contraseña</h5>
    <div *ngIf="statusLoadFailed" class="alert alert-danger">
      No se pudo consultar la configuración de contraseña. Inténtelo nuevamente
      más tarde.
    </div>
    <div
      *ngIf="passwordConfigured === false"
      class="alert alert-info"
    >
      Esta cuenta utiliza inicio de sesión con Google y no tiene una
      contraseña local configurada.
    </div>
    <form
      *ngIf="passwordConfigured"
      [formGroup]="form"
      (ngSubmit)="submit()"
    >
      <div class="mb-3">
        <label class="form-label">Contraseña actual</label>
        <input
          type="password"
          class="form-control borde-verde"
          formControlName="currentPassword"
          autocomplete="current-password"
        />
      </div>
      <div class="mb-3">
        <label class="form-label">Nueva contraseña</label>
        <input
          type="password"
          class="form-control borde-verde"
          formControlName="newPassword"
          autocomplete="new-password"
        />
      </div>
      <div class="mb-4">
        <label class="form-label">Confirmar nueva contraseña</label>
        <input
          type="password"
          class="form-control borde-verde"
          formControlName="newPasswordConfirm"
          autocomplete="new-password"
        />
      </div>
      <div class="d-flex justify-content-end gap-2">
        <button type="button" class="btn btn-outline-secondary" (click)="back()">
          Volver
        </button>
        <button
          type="submit"
          class="btn btn-success"
          [disabled]="form.invalid || loading"
        >
          Guardar contraseña
        </button>
      </div>
    </form>
  </div>
</div>
